<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="ibox-content m-b-sm border-bottom">
      <div class="row form-horizontal">
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label">Event Name</label>
          <div class="col-sm-4">
            <div>
              <el-input placeholder="Event Name" v-model="searchName" name="search"></el-input>
            </div>
          </div>
          <label class="col-sm-2 control-label">Event Id</label>
          <div class="col-sm-4">
            <div>
              <el-input placeholder="Event Id" v-model="internetContentCode" name="search"></el-input>
            </div>
          </div>
        </div>
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label">Event Group Code</label>
          <div class="col-sm-4">
            <div>
              <el-input placeholder="" v-model="crmEventGroupCode" name="search"></el-input>
            </div>
          </div>
          <label class="col-sm-2 control-label">Event Types</label>
          <div class="col-sm-4">
            <div>
              <el-select v-model="eventTypes" clearable>
                <el-option v-for="item in eventTypeObj" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label">Data Source</label>
          <div class="col-sm-4">
            <div>
              <el-select v-model="dataSource" clearable>
                <el-option v-for="item in dataSourceObj" :key="item" :label="item" :value="item"> </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label">{{ $t("message.Status") }}</label>
          <div class="col-sm-4">
            <div>
              <el-select v-model="status" clearable v-bind:placeholder="$t('message.PleaseSelect')">
                <el-option v-for="item in statusObj" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label"> Start Date </label>
          <div class="col-sm-4">
            <div>
              <el-date-picker v-model="startDate" type="date" value-format="yyyy-MM-dd 00:00:00"> </el-date-picker>
            </div>
          </div>
          <label class="col-sm-2 control-label"> End Date </label>
          <div class="col-sm-4">
            <div>
              <el-date-picker v-model="endDate" type="date" value-format="yyyy-MM-dd 00:00:00"> </el-date-picker>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12 textRight">
            <div class>
              <button class="btn btn btn-primary" style="margin-right: 15px" @click="setCRMRule">CRM Admission Status Rule</button>
              <button class="btn btn btn-primary" @click="search">{{ $t("message.Search") }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <div class="row table-responsive" style="padding-bottom: 60px">
              <div class="col-xs-12">{{ total }}{{ $t("message.datagridresult") }}</div>
              <el-table :data="rows" style="width: 100%" border ref="multipleTable" @selection-change="handleSelectionChange" @sort-change="sortChange" @row-dblclick="handleDbClick">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="internetContentCode" label="Event ID" width="200" :show-overflow-tooltip="true" sortable></el-table-column>
                <el-table-column prop="titleen_US" v-bind:label="$t('message.Title - Eng')" width="200" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="titlezh_CN" v-bind:label="$t('message.TitleTChi')" width="200" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="titlezh_HK" v-bind:label="$t('message.TitleSChi')" width="200" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="eventTypes" v-bind:label="$t('message.Event Types')" width="150" sortable></el-table-column>
                <el-table-column prop="status" v-bind:label="$t('message.Status')" width="100" sortable></el-table-column>
                <el-table-column prop="venue" v-bind:label="$t('message.venue')" width="150" sortable></el-table-column>
                <el-table-column prop="dataSource" label="Data Source" width="130"></el-table-column>
                <el-table-column prop="startDate" v-bind:label="$t('message.Start Date')" width="130" sortable></el-table-column>
                <el-table-column prop="endDate" v-bind:label="$t('message.End Date')" width="130" sortable></el-table-column>
                <el-table-column prop="updatedTime" label="Updated Time" width="150" sortable></el-table-column>
              </el-table>
              <el-col :span="24" class="el-table_footertoolbar">
                <el-pagination
                  layout="total, sizes, prev, pager, next, jumper"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="pagesize"
                  :current-page="page + 1"
                  :total="total"
                  style="float: right"
                >
                </el-pagination>
              </el-col>
            </div>
            <div class="col-sm-12 row" style="margin-top: -30px">
              <div class="pull-right">
                <button class="btn btn-white" @click="gotoDetail" v-if="checkPermission('EVENT_LIST_NEW')">{{ $t("message.Add") }}</button>
                <button class="btn btn-white" @click="showWarning" v-if="checkPermission('EVENT_LIST_DELETE')">{{ $t("message.Delete") }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="" :visible.sync="setCRMRuleDlg" width="70%" :append-to-body="true" center>
      <span>Rate of vacancy to display Limited Quota label on registration required CRM event: <el-input-number :min="1" :max="100" size="mini" v-model="rate"></el-input-number>％ Full </span>
      <span slot="footer" class="dialog-footer">
        <div class="form-group">
          <el-button @click="setCRMRuleDlg = false">Cancel</el-button>
          <el-button type="primary" @click="saveCRMRule(rate)">Save</el-button>
        </div>
      </span>
    </el-dialog>
    <el-dialog title="" :visible.sync="selectEventTypeDlg" width="70%" :append-to-body="true" center>
      <span>Which type of event group you want to create?</span>
      <span slot="footer" class="dialog-footer">
        <div class="form-group">
          <el-button @click="selectEventTypeDlg = false">Cancel</el-button>
          <el-button type="primary" @click="selectType(1)">Arts</el-button>
          <el-button type="primary" @click="selectType(2)">Exhibitions</el-button>
          <el-button type="primary" @click="selectType(8)">Exhibitions (simple)</el-button>
          <el-button type="primary" @click="selectType(3)">Talks / Forums</el-button>
        </div>
        <div class="form-group">
          <el-button type="primary" @click="selectType(4)">Guided Tour</el-button>
          <el-button type="primary" @click="selectType(5)">Workshops</el-button>
          <el-button type="primary" @click="selectType(6)">Screening</el-button>
          <el-button type="primary" @click="selectType(7)">Festival</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import eventBus from "../eventbus";
import { truncate } from "fs";
import config from "../config";

export default {
  name: "usefulLinksListController",
  mixins: [config.globalMixin],
  components: {},
  data() {
    return {
      page: 0, //当前页数
      pagesize: 10, //一页显示几条
      filter: "",
      searchName: "",
      internetContentCode: "",
      searchStatus: null,
      total: 0,
      rows: [],
      multipleSelection: [],
      sortType: "DESC",
      sortField: "id",
      selectEventTypeDlg: false,
      setCRMRuleDlg: false,
      eventTypes: "",
      crmEventGroupCode: "",
      status: "",
      eventTypeObj: [],
      statusObj: [],
      dataSourceObj: [],
      rate: "",
      startDate: "",
      endDate: "",
      dataSource: "",
    };
  },
  created: function () {
    if (this.$route.query.sortField) {
      this.sortField = this.$route.query.sortField;
    }
    if (this.$route.query.page) {
      this.page = parseInt(this.$route.query.page);
    }
    if (this.$route.query.pagesize) {
      this.pagesize = parseInt(this.$route.query.pagesize);
    }
    if (this.$route.query.searchName) {
      this.searchName = this.$route.query.searchName;
    }
    if (this.$route.query.status) {
      this.status = this.$route.query.status;
    }
    if (this.$route.query.eventTypes) {
      this.eventTypes = this.$route.query.eventTypes;
    }
    if (this.$route.query.dataSource) {
      this.dataSource = this.$route.query.dataSource;
    }
    if (this.$route.query.startDate) {
      this.startDate = this.$route.query.startDate;
    }
    if (this.$route.query.endDate) {
      this.endDate = this.$route.query.endDate;
    }
    if (this.$route.query.crmEventGroupCode) {
      this.crmEventGroupCode = this.$route.query.crmEventGroupCode;
    }
    if (this.$route.query.internetContentCode) {
      this.internetContentCode = this.$route.query.internetContentCode;
    }
  },
  methods: {
    async init() {
      let objdata = this.getAuthObj();
      objdata.sortField = this.sortField;
      objdata.sortType = this.sortType;
      objdata.startRow = this.page;
      objdata.maxRows = this.pagesize;
      objdata.title = this.searchName;
      objdata.eventTypes = this.eventTypes;
      objdata.dataSource = this.dataSource;
      objdata.startDate = this.startDate;
      objdata.endDate = this.endDate;
      objdata.crmEventGroupCode = this.crmEventGroupCode;
      objdata.status = this.status;
      objdata.internetContentCode = this.internetContentCode;
      objdata.apiUrl = "/getEventList";
      var data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      let list = null;
      for (var i = 0; i < data.data.resultList.length; i++) {
        for (var j = 0; j < data.data.resultList[i].langMap.length; j++) {
          if (data.data.resultList[i].langMap[j].langCode == "en_US") {
            data.data.resultList[i]["title" + "en_US"] = data.data.resultList[i].langMap[j].title;
          }
          if (data.data.resultList[i].langMap[j].langCode == "zh_HK") {
            data.data.resultList[i]["title" + "zh_HK"] = data.data.resultList[i].langMap[j].title;
          }
          if (data.data.resultList[i].langMap[j].langCode == "zh_CN") {
            data.data.resultList[i]["title" + "zh_CN"] = data.data.resultList[i].langMap[j].title;
          }
        }
      }
      this.rows = data.data.resultList;
      this.setObj();
      this.total = data.data.totalRows;
    },
    gotoDetail() {
      this.selectEventTypeDlg = true;
    },
    selectType: function (type) {
      this.selectEventTypeDlg = false;
      this.$router.push({
        path: "/main/eventDetail",
        query: {
          type: type,
          sortField: this.sortField,
          page: this.page,
          pagesize: this.pagesize,
          searchName: this.searchName,
          status: this.status,
          eventTypes: this.eventTypes,
          dataSource: this.dataSource,
          startDate: this.startDate,
          endDate: this.endDate,
          crmEventGroupCode: this.crmEventGroupCode,
          internetContentCode: this.internetContentCode,
        },
      });
    },
    getStatus(data) {
      if (data.indexOf("all") < 0) {
        this.searchStatus = Number(data);
      } else {
        this.searchStatus = null;
      }
    },
    async search() {
      this.page = 0;
      this.init();
    },
    showWarning() {
      var that = this;
      if (this.multipleSelection.length != 0) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [
            {
              name: this.$i18n.t("message.Confirm"),
              callBack: function () {
                that.deleteList();
              },
            },
            {
              name: this.$i18n.t("message.Cancel"),
              callBack: function () {},
            },
          ],
        });
      }
    },
    async deleteList() {
      let ids = [];
      let objdata = this.getAuthObj();
      if (this.multipleSelection.length != 0) {
        for (let i = 0; i < this.multipleSelection.length; i++) {
          ids.push(this.multipleSelection[i].id);
        }
      }
      objdata.ids = ids;

      objdata.apiUrl = "/deleteEvent";
      var data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      if (data.data.errorCode === 0) {
        this.$store.commit("setwarning", {
          string: "",
          boolean: false,
          button: [],
        });
        this.init();
      }
    },
    cancel: function () {
      this.$store.commit("setwarning", { string: "", boolean: false });
    },
    handleSizeChange: function (val) {
      this.pagesize = val;
      this.init();
    },
    handleCurrentChange: function (val) {
      this.page = val - 1;
      this.init();
    },
    handleSelectionChange: function (val) {
      this.multipleSelection = val;
    },
    handleDbClick: function (row) {
      this.$router.push({
        path: "/main/eventDetail",
        query: {
          id: row.id,
          type: row.eventTypes,
          sortField: this.sortField,
          page: this.page,
          pagesize: this.pagesize,
          searchName: this.searchName,
          status: this.status,
          eventTypes: this.eventTypes,
          dataSource: this.dataSource,
          startDate: this.startDate,
          endDate: this.endDate,
          crmEventGroupCode: this.crmEventGroupCode,
          internetContentCode: this.internetContentCode,
        },
      });
    },
    sortChange: function (val) {
      if (val.order == "ascending") {
        this.sortType = "ASC";
        this.sortField = val.prop;
      } else if (val.order == "descending") {
        this.sortType = "DESC";
        this.sortField = val.prop;
      } else {
        this.sortType = "ASC";
        this.sortField = "id";
      }
      this.init();
    },
    async setObj() {
      this.eventTypeObj = [
        {
          value: "1",
          label: "Performing Arts",
        },
        {
          value: "2",
          label: "Exhibitions",
        },
        {
          value: "3",
          label: "Talks / Forums",
        },
        {
          value: "4",
          label: "Guided Tour",
        },
        {
          value: "5",
          label: "Workshops",
        },
        {
          value: "6",
          label: "Screening",
        },
        {
          value: "7",
          label: "Festival",
        },
      ];
      this.statusObj = [
        {
          value: "0",
          label: this.$i18n.t("message.Draft"),
        },
        {
          value: "10",
          label: this.$i18n.t("message.Publish"),
        },
        {
          value: "1",
          label: this.$i18n.t("message.Unpublish"),
        },
        {
          value: "2",
          label: "Expired",
        },
      ];
      this.dataSourceObj = ["SISTIC", "CRM"];

      let objdata = this.getAuthObj();
      objdata.sortField = "id";
      objdata.sortType = "ASC";
      objdata.startRow = 0;
      objdata.maxRows = 1000000;
      objdata.status = 1;
      objdata.apiUrl = "/getVenueList";
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      this.venueList = data.data.resultList;
      this.venueObj = [];
      for (var i = 0; i < this.venueList.length; i++) {
        this.venueObj.push({
          value: this.venueList[i].id + "",
          label: this.getObject(this.venueList[i].langMap, this.langKey[0]).content,
        });
      }

      let list = null;
      for (list of this.rows) {
        if (list.status === 0) {
          list.status = this.$i18n.t("message.Draft");
        } else if (list.status == 10) {
          list.status = this.$i18n.t("message.Publish");
        } else if (list.status == 1) {
          list.status = this.$i18n.t("message.Unpublish");
        } else if (list.status == 2) {
          list.status = "Expired";
        }
        if (list.eventTypes == 1) {
          list.eventTypes = "Performing Arts";
        } else if (list.eventTypes == 2) {
          list.eventTypes = "Exhibitions";
        } else if (list.eventTypes == 3) {
          list.eventTypes = "Talks / Forums";
        } else if (list.eventTypes == 4) {
          list.eventTypes = "Guided Tour";
        } else if (list.eventTypes == 5) {
          list.eventTypes = "Workshops";
        } else if (list.eventTypes == 6) {
          list.eventTypes = "Screening";
        } else if (list.eventTypes == 7) {
          list.eventTypes = "Festival";
        }
        if (list.venue) {
          list.venue = list.venue.split(",");
          var str = [];
          list.venue.forEach(item => {
            this.venueObj.forEach(obj => {
              if (item == obj.value) {
                str.push(obj.label);
              }
            });
          });
          list.venue = str.join(", ");
        }
      }
    },
    async setCRMRule() {
      let objdata = this.getAuthObj();
      objdata.apiUrl = "/getEventRateOfVacancy";
      var data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      this.rate = data.data.result;
      this.setCRMRuleDlg = true;
    },
    async saveCRMRule(rate) {
      let objdata = this.getAuthObj();
      objdata.rate = rate;
      objdata.apiUrl = "/saveEventRateOfVacancy";
      var data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      this.ruleDetail = data.data.result;
      this.setCRMRuleDlg = false;
    },
  },
  mounted() {
    this.init();
  },
};
</script>
